import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

import Home from "@/pages/Home";
import About from "@/pages/About";
import NeurologyServices from "@/pages/NeurologyServices";
import PsychologyServices from "@/pages/PsychologyServices";
import OnlineConsultation from "@/pages/OnlineConsultation";
import PatientCare from "@/pages/PatientCare";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const HideEmergentBadge = () => {
  useEffect(() => {
    const hide = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.style.setProperty("display", "none", "important");
    };
    hide();
    const obs = new MutationObserver(hide);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HideEmergentBadge />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/neurology" element={<NeurologyServices />} />
            <Route path="/psychology" element={<PsychologyServices />} />
            <Route path="/online-consultation" element={<OnlineConsultation />} />
            <Route path="/patient-care" element={<PatientCare />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
